<template>
    <div class="main-content">
        <div class="main-content-heading">
            <h1>Online spätná väzba</h1>
            <div class="back">
                <a @click="$router.go(-1)">&lt; Späť</a>
            </div>
        </div>
        <div class="heading-spliter"></div>
        <div class="text-mute">
            V rámci jedného prieskumu môžete hodnotiť viac osôb. Zvoľte osobu, ktorú chcete hodnotiť teraz a zobrazí
            sa Vám dotazník s otázkami. Celý prieskum je anonymný, hodnotený ani správcovia systému nevidia,
            ako ste na ktorú otázku odpovedali. V prípade akýchkoľvek otázok nás prosím kontaktujte
            e-mailom na adresu: info@maxman-consultants.com.
        </div>
        <div class="persons-content">
            <div v-if="evaluations && evaluations.length > 0">
                <div v-for="evaluation in evaluations" class="main-content-box">
                    <div class="left">
                        <h3>{{evaluation.evaluated.name + ' ' + evaluation.evaluated.lastname}}</h3>
                        <div v-if="evaluation.role_id == 1" class="text-mute">Podriadený</div>
                        <div v-else-if="evaluation.role_id == 2" class="text-mute">Nadriadený</div>
                        <div v-else-if="evaluation.role_id == null" class="text-mute">Sebahodnotenie</div>
                        <div v-else class="text-mute">{{evaluation.feedback_role.name}}</div>
                    </div>
                    <div class="right">
                        <router-link
                            class="button"
                            :to="{name: 'feedback', params: {courseId: id,
                                                            relationId: evaluation.id,
                                                            evaluatedName: evaluation.evaluated.name + ' ' + evaluation.evaluated.lastname,
                                                            roleId: evaluation.role_id
                            }}"
                        >Hodnotiť ></router-link>
                    </div>
                </div>
            </div>
            <div v-else>
                <h2>Nie sú priradené žiadne hodnotenia</h2>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["id"],
    components: {},
    mixins: [],
    data() {
        return {
            evaluations: null
        };
    },
    mounted() {},
    created() {
        this.refresh();
    },
    methods: {
        refresh() {
            this.$api.server
                .get("api/public/feedback/relations/" + this.id)
                .then(r => {
                    this.evaluations = r.data.evaluatedList;
                });
        }
    },
    computed: {},
    watch: {},
    validations() {}
};
</script>
<style lang="css">
.persons-content {
    margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/public_app/pages/feedback/FeedbackPersons.vue